import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import { useNavigate } from "react-router-dom";
import useStore from "utils/reportStore";
import Session from "utils/Session";
import GradeReportButton from "../GradeReportButton";
import CustomAccordion from "./CustomAccordion";
import PartWithAnswers from "./PartWithAnswers";

const OVERALL = -1;

export default function Sidebar({ data, ...props }) {
    const navigate = useNavigate();
    const section = useStore((state) => state.section);
    const sections = useStore((state) => state.sections);
    const setSection = useStore((state) => state.setSection);
    const { parts = [], questions = [] } = useStore((state) => state.sections?.[section] || {});
    const setCurrentQuestion = useStore((state) => state.setCurrentQuestion);
    const setPartIndex = useStore((state) => state.setPartIndex);

    const isB2C = Session.hasB2CAccess;

    const handleSectionChange = (index, state) => {
        (state) ? setSection(index) : setSection(-1);

        setCurrentQuestion(null);
        setPartIndex(null);
    }

    const handleAnswerClick = (answerIndex, partIndex) => {
        setCurrentQuestion(answerIndex);
        setPartIndex(partIndex);
    }

    return (
        <Box
            height={'97%'} borderRadius={1} mx={2}
            boxShadow='0px 0px 12px rgba(0, 0, 0, 0.16)'
            width={200} minWidth={200}
            backgroundColor='#ffffff' mb={1}
            display='flex' flexDirection='column'
            {...props}
        >
            {/* Scrollable content */}
            <Box flex={1} overflow='auto' p={2}>
                <GradeReportButton
                    ielts mb={2} active={section === OVERALL}
                />

                <Divider orientation="horizontal" />

                <p></p>
                <Typography variant="h6-medium">
                    Section Analysis
                </Typography>
                <p></p>

                {sections.map((sec, index) => (
                    <Box key={index}>
                        <CustomAccordion
                            open={section === index} label={sec.name}
                            index={index} onChange={handleSectionChange}
                        >
                            {parts.map((part, index) => (
                                <PartWithAnswers
                                    index={index}
                                    questions={questions}
                                    onAnswerClick={handleAnswerClick}
                                    key={index} mb={1}
                                />
                            ))}
                        </CustomAccordion>
                        <br />
                    </Box>
                ))}
            </Box>

            {/* B2C-only practice button pinned at bottom */}
            {isB2C && (
                <Box p={2} borderTop='1px solid #E5E7EB'>
                    <Button
                        fullWidth
                        variant="contained"
                        disableElevation
                        startIcon={<AssignmentOutlinedIcon sx={{ fontSize: '1rem' }} />}
                        onClick={() => navigate('/practice')}
                        sx={{
                            backgroundColor: '#1E90FF',
                            color: '#FFFFFF',
                            borderRadius: '8px',
                            textTransform: 'none',
                            fontWeight: 600,
                            fontSize: '0.82rem',
                            fontFamily: 'Mulish, sans-serif',
                            padding: '9px 12px',
                            '&:hover': { backgroundColor: '#1a7de0' },
                        }}
                    >
                        Practice Tests
                    </Button>
                </Box>
            )}
        </Box>
    );
}